import '../styling/NewLogin.css';
import team from '../resources/happyman.jpg';
import { Link } from "react-router-dom";
import {useState} from 'react';
import { useLogin } from "../hooks/useLogin";

const NewLogin = () => {

    const{login, isLoading, error} = useLogin();

    const[email,setEmail] = useState('')
    const[password,setPassword] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        login(email,password,isLoading)
    }

    return ( 
        <div className="signupcontainer">
           
            <div className="signupleft">
                <form onSubmit={handleSubmit} id="signupform">
                <div className="error2">
                {error && 
            <div className="alert alert-error">
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span>Error! {error}</span>
            </div>}
            </div>   
                
                    <h1 id="signuptry">Try InvoiceMaster Pro Free Today!</h1>
                    <div className="signupemail">
                    <input type="email" placeholder="Email" className="input input-bordered input-info w-full max-w-m" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="signupemail">
                    <input type="password" placeholder="Password" className="input input-bordered input-info w-full max-w-m" value={password} onChange={(e) => setPassword(e.target.value)}/>
                    </div>
                    <div className="signupremember">
                    <input id="link-checkbox" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                    <h2>Remember me</h2>
                    </div>
                    <div className="signupsubmit">
                    {isLoading ? <span className="loading loading-spinner text-info"></span> :<button className="btn">Submit</button>}
                    </div>
                    <div className="signupalready">
                        <h2>Don't have an account?</h2>
                        <Link to="/signup" style={{textDecoration: 'none'}}>
                        <h2 id="loginhere">Signup here</h2>
                        </Link>
                    </div>
                    
        
                    
                    </form>  
            </div>
            <div class="signupright">
            <img src={team} alt="team" id="team2" />
            <h1 id="signuprightwork">Welcome Back!</h1>
            <h1 id="loginbenefits">Welcome back to InvoiceMaster Pro! We're thrilled to have you back on board. Your go-to platform for seamless and efficient invoice management is ready to empower your business once again.</h1>
            </div>


        </div>
     );
}
 
export default NewLogin;